import React from 'react'
import Helmet from 'react-helmet'

const wealthURL = 'https://wealth.northerntrust.com' // process.env.GATSBY_SITE_URL;
const twitterCreator = '@NTWealth'

class HelmetBuilder extends React.Component {
  constructor(props) {
    super(props)

    this.addScripts = this.addScripts.bind(this)
    this.addStyles = this.addStyles.bind(this)
    this.addLinks = this.addLinks.bind(this)
  }

  addScripts() {
    return [
      // add scripts as needed
    ]
  }

  addStyles() {
    return []
  }

  addLinks() {
    return [
      {
        rel: 'canonical',
        href: `${wealthURL}`,
      },
    ]
  }

  render() {
    let title

    if (this.props.title) {
      title = `${this.props.title.trim()}`
    }

    let bodyClasses

    if (this.props.bodyClasses) {
      bodyClasses = this.props.bodyClasses
    }

    let meta = []

    meta.push(
      {
        property: 'og:title',
        content: title,
      },
      {
        name: 'twitter:title',
        content: title,
      }
    )

    if (this.props.description) {
      meta.push(
        {
          name: 'description',
          content: this.props.description,
        },
        {
          property: 'og:description',
          content: this.props.description,
        },
        {
          name: 'twitter:description',
          content: this.props.description,
        }
      )
    }

    if (this.props.image) {
      meta.push({
        property: 'og:image',
        content: `https:${this.props.image}?fm=jpg&q=90`,
        //h=630&w=1200&
      })
    }

    // if (metadataInfo.twitterimage) {
    meta.push({
      name: 'twitter:image',
      content: `https:${this.props.image}?fm=jpg&q=90`,
      //h=630&w=1200&
    })
    // }

    meta.push({
      name: 'twitter:creator',
      content: twitterCreator,
    })
    // }

    if (this.props.pathname) {
      meta.push({
        property: 'og:url',
        content: `${wealthURL}${this.props.pathname}`,
      })
    }

    // if (metadataInfo.keywords) {
    //   meta.push({
    //     property: 'keywords',
    //     content: metadataInfo.keywords.join(','),
    //   })
    // }

    meta.push({
      property: 'og:type',
      content: 'website',
    })

    meta.push({
      name: 'twitter:card',
      content: 'summary_large_image',
    })

    const additionalAttributes = !bodyClasses
      ? {}
      : {
          bodyAttributes: {
            class: bodyClasses,
          },
        }

    const styles = this.addStyles()
    const scripts = this.addScripts()
    const links = this.addLinks()

    return (
      <Helmet
        title={title}
        meta={meta}
        script={scripts}
        style={styles}
        links={links}
        {...additionalAttributes}
      />
    )
  }
}

export default HelmetBuilder
